import { ensureAppReviewCommentCollectionData, ensureClearAppReviewCommentCollectionData, createAppReviewComment, ensureAppReviewCommentCollectionStateInitialized } from '@shared/actions/thunkActions';
import { AppReviewCommentCollection as AppReviewCommentCollectionComponent } from '@shared/components/appReviewCommentCollection';
import { connect } from 'react-redux';
import { createModalAction, createEntityReviewCommentModalAction, createEntityReviewCommentsUnloadPagesAction } from '@shared/actions/actions';
import { Constants } from '@shared/utils/constants';
const mapStateToProps = (state, ownProps)=>{
    var _state_apps_appReviewsData, _state_apps, _ownProps_review, _state_apps_appReviewsData1, _state_apps1, _state_users;
    const commentsState = ((_state_apps = state.apps) === null || _state_apps === void 0 ? void 0 : (_state_apps_appReviewsData = _state_apps.appReviewsData) === null || _state_apps_appReviewsData === void 0 ? void 0 : _state_apps_appReviewsData.reviewComments) && ((_state_apps1 = state.apps) === null || _state_apps1 === void 0 ? void 0 : (_state_apps_appReviewsData1 = _state_apps1.appReviewsData) === null || _state_apps_appReviewsData1 === void 0 ? void 0 : _state_apps_appReviewsData1.reviewComments[(_ownProps_review = ownProps.review) === null || _ownProps_review === void 0 ? void 0 : _ownProps_review.id]) || null;
    return {
        signedIn: (_state_users = state.users) === null || _state_users === void 0 ? void 0 : _state_users.signedIn,
        comments: commentsState,
        expanded: ownProps.expanded,
        locale: ownProps.locale,
        review: ownProps.review,
        isStateInitialized: commentsState !== null
    };
};
const mapDispatchToProps = (dispatch)=>{
    return {
        loadData: ({ offerId, reviewId, page, itemsPerPage })=>dispatch(ensureAppReviewCommentCollectionData({
                offerId,
                reviewId,
                page,
                itemsPerPage
            })),
        clearData: ({ offerId, reviewId })=>dispatch(ensureClearAppReviewCommentCollectionData({
                offerId,
                reviewId
            })),
        createComment: ({ offerId, reviewId, content, addToNewlyAdded })=>dispatch(createAppReviewComment({
                offerId,
                reviewId,
                commentContent: content,
                isNewlyAddedComment: addToNewlyAdded
            })),
        editComment: ({ offerId, reviewId, commentId, updatedContent, isNewlyAddedComment = false })=>dispatch(createEntityReviewCommentModalAction({
                showModal: true,
                modalMode: Constants.Reviews.ReviewCommentModalMode.ConfirmUpdate,
                actionPayload: {
                    offerId,
                    reviewId,
                    commentId,
                    commentContent: updatedContent,
                    isNewlyAddedComment
                }
            })),
        deleteComment: ({ offerId, reviewId, commentId, isNewlyAddedComment = false })=>dispatch(createEntityReviewCommentModalAction({
                showModal: true,
                modalMode: Constants.Reviews.ReviewCommentModalMode.ConfirmDelete,
                actionPayload: {
                    commentId,
                    reviewId,
                    offerId,
                    isNewlyAddedComment
                }
            })),
        openModal: ({ modalId })=>{
            return dispatch(createModalAction({
                showModal: true,
                modalId: modalId
            }));
        },
        ensureStateInitialized: ({ offerId, reviewId, totalComments })=>{
            return dispatch(ensureAppReviewCommentCollectionStateInitialized({
                offerId,
                reviewId,
                totalComments
            }));
        },
        unloadPages: ({ offerId, reviewId })=>{
            return dispatch(createEntityReviewCommentsUnloadPagesAction({
                offerId,
                reviewId
            }));
        }
    };
};
export const AppReviewCommentCollection = connect(mapStateToProps, mapDispatchToProps)(AppReviewCommentCollectionComponent);
